import { NgModule } from '@angular/core';

import { PricingFeatureFacade, PricingFeatureObservableModel } from '@recruitee/pricing';

import { PricingFeatureConnectedFacade } from './pricing-feature-connected.facade';
import { PricingFeatureConnectedModel } from './pricing-feature-connected.model';

@NgModule({
  providers: [
    [
      {
        provide: PricingFeatureFacade,
        useClass: PricingFeatureConnectedFacade,
      },
      {
        provide: PricingFeatureObservableModel,
        useClass: PricingFeatureConnectedModel,
      },
    ],
  ],
})
export class RtPricingFeatureConnectedModule {}
